import { LOB, PopulationType } from '../common/Constants';
import { GuestData } from '../store/useGuestStore/guestStore';

export const getMemberDataFromGuestData = (guestData: GuestData) => {
  const {
    coverageEffectiveDate,
    coverageType,
    lob,
    ndbLob,
    stateCode,
    zipCode,
  } = guestData || {};

  const demographics = {
    state: stateCode,
    zipCode,
  };

  const eligibility = [
    {
      memberHealthCoverage: {
        coverageType: [
          {
            coverageEffDateRange: {
              startDate: coverageEffectiveDate,
              endDate: '9999-12-31',
            },
            typeCode: {
              coverageTypeCode: coverageType?.toUpperCase(),
              reciprocityId: ndbLob,
            },
          },
        ],
      },
    },
  ];

  let population: PopulationType;
  let lineOfBusiness: LOB;
  let isIFPEarlyPay = false;

  switch (lob?.toUpperCase()) {
    case 'IFPEARLYPAY':
      isIFPEarlyPay = true;
      population = PopulationType.IFP;
      lineOfBusiness = LOB.IFP;
      break;
    default:
      population = PopulationType.IFP;
      lineOfBusiness = LOB.IFP;
  }

  return {
    demographics,
    eligibility,
    isIFPEarlyPay,
    population,
    reciprocityId: ndbLob,
    lineOfBusiness,
  };
};

export const getIsIFPEarlyPay = (guestData: GuestData) => {
  const { portalSource, coverageType, lob } = guestData || {};

  return (
    portalSource?.toUpperCase() === 'IFPEARLYPAY' &&
    coverageType?.toUpperCase() === 'M' &&
    lob?.toUpperCase() === 'IFPEARLYPAY'
  );
};

// Add more population checks here as needed
export const getIsGuestUser = (guestData: GuestData) =>
  getIsIFPEarlyPay(guestData);
